import React from 'react';
import { GridRenderCellParams, gridDetailPanelExpandedRowsContentCacheSelector, useGridApiContext, useGridSelector } from '@mui/x-data-grid-pro';
import { IconButton } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faCaretRight } from '@fortawesome/free-solid-svg-icons';
import { responseTimeMeasurement } from '../../apm/response-time-measurement';

export function DetailPanelToggle(props: Pick<GridRenderCellParams, 'id' | 'value'>) {
  const { id, value: isExpanded } = props;
  const apiRef = useGridApiContext();
  const contentCache = useGridSelector(apiRef, gridDetailPanelExpandedRowsContentCacheSelector);

  if (!React.isValidElement(contentCache[id])) {
    return null;
  }

  return (
    <IconButton size="small" sx={{ width: '25px' }} tabIndex={-1} aria-label={isExpanded ? 'Luk' : 'Åbn'} {...responseTimeMeasurement('RowWithDetail')}>
      <FontAwesomeIcon icon={isExpanded ? faCaretDown : faCaretRight} />
    </IconButton>
  );
}
